import { render } from "./ErpCustomerExternalSelect.vue?vue&type=template&id=5754aa8f&scoped=true"
import script from "./ErpCustomerExternalSelect.vue?vue&type=script&lang=js"
export * from "./ErpCustomerExternalSelect.vue?vue&type=script&lang=js"

import "./ErpCustomerExternalSelect.vue?vue&type=style&index=0&id=5754aa8f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5754aa8f"],['__file',"src/components/h5/partner/ErpCustomerExternalSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5754aa8f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5754aa8f', __exports__)) {
    api.reload('5754aa8f', __exports__)
  }
  
  module.hot.accept("./ErpCustomerExternalSelect.vue?vue&type=template&id=5754aa8f&scoped=true", () => {
    api.rerender('5754aa8f', render)
  })

}


export default __exports__